enum FORM_NAMES {
  junior = 'junior',
  middle = 'middle',
  senior = 'senior',
  others = 'others',
  numberOfGuests = 'number_of_guests',
}

const SHOW_MODAL_AFTER_SPLASH_TIMEOUT = 3000;

const POLICE_TYPE_CODE = ['FAKE', 'NAT'];

export {FORM_NAMES, POLICE_TYPE_CODE, SHOW_MODAL_AFTER_SPLASH_TIMEOUT};
